import BindModel from './bind-model';
import RuleModel from './rule-model';

export default class RuleFactory {
    static create(family, fields = {}) {
        switch (family) {
            case RuleModel.Types.rule.family:
                return new RuleModel(fields);
            case RuleModel.Types.bind.family:
                return new BindModel(fields);
            default:
                throw new Error('Invalid rule type');
        }
    }
}
